import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { InternationalData } from '../../shared/international-data/international-data'
import * as fromActions from '../actions'

export const internationalDataFeatureKey = 'internationalData'

export interface InternationalDataState extends EntityState<InternationalData> {
  loading: boolean
  loaded: boolean
}

const entityAdapter: EntityAdapter<InternationalData> = createEntityAdapter<InternationalData>({
  selectId: (internationalData) => internationalData.country,
  sortComparer: (a, b) => (a.countryCode === '+39' ? -1 : a.country.localeCompare(b.country)),
})

export const initialState: InternationalDataState = entityAdapter.getInitialState({
  loaded: false,
  loading: false,
})

export const reducer = (
  state = initialState,
  action: fromActions.RequireInternationalDataGuardActions | fromActions.InternationalDataEffectActions,
): InternationalDataState => {
  switch (action.type) {
    case fromActions.RequireInternationalDataGuardActionTypes.InternationalDataNotFound:
      return { ...state, loading: true }
    case fromActions.InternationalDataEffectActionTypes.InternationalDataLoadSuccess:
      return { ...entityAdapter.setAll(action.list, state), loading: false, loaded: true }
    case fromActions.InternationalDataEffectActionTypes.InternationalDataLoadFail:
      return { ...state, loading: false }
    default:
      return state
  }
}

export const { selectAll: getList, selectEntities: getEntities } = entityAdapter.getSelectors() || {}

export const getLoaded = (state: InternationalDataState) => state.loaded
export const getLoading = (state: InternationalDataState) => state.loading
